module.exports = __webpack_public_path__ + "img/seguranca-mercado-pago.58d20131.svg";